module.exports = __webpack_public_path__ + "img/icon_lottery_no.e49b6f4a.png";